import { useState } from "react";
import { IconButton, Stack } from "@introist/react-foundation/v2";
import { PaintBucket } from "lucide-react";
import { HexColorPickerPopover } from "./components/HexColorPickerPopover";

export const BackgroundSelector = ({
  onSelect,
  onClear,
  color
}: {
  onSelect: (color: string) => void;
  onClear: () => void;
  color: string;
}) => {
  const [popoverRef, setPopoverRef] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  const handleButtonClick = () => {
    setOpen(true);
  };

  return (
    <>
      <Stack ref={setPopoverRef}>
        <IconButton
          icon={
            <PaintBucket
              size={16}
              style={{
                stroke: color
              }}
            />
          }
          onClick={handleButtonClick}
          size="large"
          active={!!color}
        />
      </Stack>
      <HexColorPickerPopover
        referenceElement={popoverRef}
        onClose={() => {
          setOpen(false);
        }}
        open={open}
        onSelect={onSelect}
        onClear={onClear}
        color={color}
      />
    </>
  );
};
